"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpTopMenuMobile = void 0;
const gs_1 = require("@ivanlog/gs");
const App_1 = require("../App");
const tmpls_1 = require("./tmpls");
const StateSearch_1 = require("../../appProfiMall/states/StateSearch");
const Helper_1 = require("../Helper");
class CmpTopMenuMobile extends tmpls_1.CmpTopMenuMobileBase {
    constructor() {
        super();
        App_1.App.Inst.gui.onChangePage.addHandler(() => { this.close(); this.ctrls.iSearchQuery.value = ''; });
        const ctrl = this.ctrls;
        ctrl.cmpCatalog.isMobile = true;
        ctrl.btnMenu.onclick = () => {
            this.addClass(CmpTopMenuMobile.ToggledMenu);
            ctrl.btnClose.show();
        };
        ctrl.btnClose.onclick = () => this.close();
        ctrl.btnAbout.onclick = () => {
            ctrl.listMenu.hide();
            ctrl.listAbout.show();
            ctrl.btnBack.show();
            ctrl.btnBack.onclick = () => {
                ctrl.listMenu.show();
                ctrl.listAbout.hide();
                ctrl.btnBack.hide();
            };
        };
        ctrl.btnCatalog.onclick = () => {
            this.removeClass(CmpTopMenuMobile.ToggledMenu);
            this.addClass(CmpTopMenuMobile.ToggledCatalog);
            ctrl.cmpCatalog.openMainCatalog();
            ctrl.btnBack.show();
            ctrl.btnBack.onclick = () => {
                if (ctrl.cmpCatalog.openMainCatalog())
                    return;
                this.removeClass(CmpTopMenuMobile.ToggledCatalog);
                this.addClass(CmpTopMenuMobile.ToggledMenu);
                ctrl.btnBack.hide();
            };
        };
        //настройка поиска
        ctrl.btnResetInput.onclick = () => {
            ctrl.iSearchQuery.value = "";
            ctrl.btnResetInput.hide();
        };
        ctrl.iSearchQuery.el.oninput = () => {
            ctrl.btnResetInput.showSet(ctrl.iSearchQuery.value != "");
        };
        Helper_1.Helper.addEnterPressEvent(ctrl.iSearchQuery.el, () => this._trySearchAsync());
    }
    close() {
        const ctrl = this.ctrls;
        this.removeClass(CmpTopMenuMobile.ToggledMenu);
        this.removeClass(CmpTopMenuMobile.ToggledCatalog);
        ctrl.btnClose.hide();
        ctrl.btnBack.hide();
        ctrl.listMenu.show();
        ctrl.listAbout.hide();
    }
    openCatalog() {
        this.ctrls.btnCatalog.el.click();
        this.ctrls.btnClose.show();
    }
    _trySearchAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const value = this.ctrls.iSearchQuery.value;
            if (!value)
                return;
            if (gs_1.StateGS.ActiveState && gs_1.StateGS.ActiveState.name == StateSearch_1.StateSearch.StateName) {
                gs_1.StateGS.ActiveState.search(value);
                return;
            }
            gs_1.StateGS.Run(StateSearch_1.StateSearch, { query: value });
        });
    }
}
exports.CmpTopMenuMobile = CmpTopMenuMobile;
CmpTopMenuMobile.ToggledMenu = "menu_opened";
CmpTopMenuMobile.ToggledCatalog = "catalog_opened";
//# sourceMappingURL=CmpTopMenuMobile.js.map